import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  open: boolean;
  title: string;
  icon?: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Right-side drawer (~520px) used only for individual compliance-check detail
 * and individual screening-record detail (spec §7.4). Backdrop dims the page;
 * Escape and backdrop click close it.
 */
const ExportDrawer: React.FC<Props> = ({
  open,
  title,
  icon,
  onClose,
  children,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className='eh-drawer-overlay' onClick={onClose}>
      <div
        className='eh-drawer'
        role='dialog'
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='eh-drawer-head'>
          <span className='eh-drawer-title'>
            {icon}
            {title}
          </span>
          <button
            className='eh-drawer-close'
            onClick={onClose}
            aria-label='Close'
            type='button'
          >
            <CloseIcon style={{ fontSize: 20 }} />
          </button>
        </div>
        <div className='eh-drawer-body'>{children}</div>
      </div>
    </div>
  );
};

export default ExportDrawer;
